// extracted by mini-css-extract-plugin
module.exports = {"snackbarList":"SnackbarList_snackbarList__1nHwU"};